
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("L8a1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $48725251417bd87c$export$2e2bcd8739ae039);

var $6YBzY = parcelRequire("6YBzY");

var $lAJ9h = parcelRequire("lAJ9h");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $03Jij = parcelRequire("03Jij");

var $cj90I = parcelRequire("cj90I");
const $48725251417bd87c$export$b77003581b60602c = ({ issueViewRelayFragment: issueViewRelayFragment, rootRelayFragment: rootRelayFragment })=>{
    const issue = (0, $8Uumt.useFragment)((0, $lAJ9h.default), issueViewRelayFragment || null);
    const root = (0, $8Uumt.useFragment)((0, $6YBzY.default), rootRelayFragment?.jira || null);
    if (issue == null || root == null || root.userPreferences == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03Jij.RedactionFlag), {
        issue: issue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cj90I.RedactionOnboardingSpotlight), {
        issue: issue,
        user: root.userPreferences
    }));
};
const $48725251417bd87c$var$RedactionOnboardingAndFlag = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-view-redaction-onboarding-flag",
        packageName: "issue-view-redaction-onboarding-flag",
        teamName: "JDM - Gunther",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48725251417bd87c$export$b77003581b60602c, props));
};
var $48725251417bd87c$export$2e2bcd8739ae039 = $48725251417bd87c$var$RedactionOnboardingAndFlag;

});
parcelRegister("6YBzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f850a634c79584e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26ae5d367b75522c91c878312641c654>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f850a634c79584e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$f850a634c79584e8$var$node.hash = "92092fd59fe761bb50a7208df52eb315";
var $f850a634c79584e8$export$2e2bcd8739ae039 = $f850a634c79584e8$var$node;

});

parcelRegister("lAJ9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef75d7553cd338f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<547de3b68323bb8dae94d034cb49549f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aef75d7553cd338f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue"
        },
        {
            "kind": "FragmentSpread",
            "name": "flag_issueViewRedaction_RedactionFlag"
        }
    ],
    "type": "JiraIssue"
};
$aef75d7553cd338f$var$node.hash = "40d55c8347d5247734b0125723e9e175";
var $aef75d7553cd338f$export$2e2bcd8739ae039 = $aef75d7553cd338f$var$node;

});

parcelRegister("03Jij", function(module, exports) {

$parcel$export(module.exports, "RedactionFlag", () => $7dc9cb047aebd58f$export$1c38786ecf80ac39);

var $2vVSV = parcelRequire("2vVSV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $2gCtH = parcelRequire("2gCtH");

var $dyFAf = parcelRequire("dyFAf");

var $ni3QF = parcelRequire("ni3QF");
const $7dc9cb047aebd58f$export$1c38786ecf80ac39 = ({ issue: issue })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { lastRedactionTime: lastRedactionTime } = (0, $8Uumt.useFragment)((0, $2vVSV.default), issue);
    const shouldShowFlag = (0, $5uXOq.useMemo)(()=>{
        if (lastRedactionTime) {
            const lastViewedTimestamp = (0, $ni3QF.getLastViewedTimestamp)(issueKey);
            const lastRedactedTimeStamp = lastRedactionTime ? new Date(lastRedactionTime).getTime() : 0;
            return lastViewedTimestamp < lastRedactedTimeStamp;
        }
        return false;
    }, [
        issueKey,
        lastRedactionTime
    ]);
    const handleShowFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            id: 'redaction-flag',
            isAutoDismiss: false,
            type: 'info',
            title: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $dyFAf.default).titleIssueTerminologyRefreshM4 : (0, $dyFAf.default).title,
            messageId: 'issue-view-redaction.ui.flag.show-flag.info',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $dyFAf.default).link,
                    href: 'https://support.atlassian.com/jira-software-cloud/docs/how-redaction-works/',
                    target: '_blank'
                }
            ]
        });
    }, [
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowFlag) {
            handleShowFlag();
            (0, $ni3QF.setLastViewedTimestamp)(issueKey);
        }
    }, [
        handleShowFlag,
        issueKey,
        shouldShowFlag
    ]);
    return null;
};

});
parcelRegister("2vVSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3bd8e56620ee50d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfddefdae384084dbca7eadfefbfb033>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3bd8e56620ee50d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "flag_issueViewRedaction_RedactionFlag",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "lastRedactionTime"
        }
    ],
    "type": "JiraIssue"
};
$e3bd8e56620ee50d$var$node.hash = "600b9b0116e7e1b66ab1f14bc11a5f02";
var $e3bd8e56620ee50d$export$2e2bcd8739ae039 = $e3bd8e56620ee50d$var$node;

});

parcelRegister("dyFAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3023f282c40952$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f3023f282c40952$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-redaction.flag.title",
        "defaultMessage": "Your organization has redacted sensitive data from this issue."
    },
    link: {
        "id": "issue-redaction.flag.link",
        "defaultMessage": "How redaction works"
    },
    titleIssueTerminologyRefreshM4: {
        "id": "issue-redaction.flag.title-issue-terminology-refresh-m4",
        "defaultMessage": "Your organization has redacted sensitive data from this work item."
    }
});

});

parcelRegister("ni3QF", function(module, exports) {

$parcel$export(module.exports, "setLastViewedTimestamp", () => $26c278bb4b945873$export$1872ab2157997f27);
$parcel$export(module.exports, "getLastViewedTimestamp", () => $26c278bb4b945873$export$ff25dd7994c58674);

var $bSSG7 = parcelRequire("bSSG7");
const $26c278bb4b945873$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('jira-redaction-flag');
const $26c278bb4b945873$var$key = 'lastViewedTimestamp';
const $26c278bb4b945873$export$1872ab2157997f27 = (issueKey)=>{
    const timestampMap = $26c278bb4b945873$var$localStorageProvider.get($26c278bb4b945873$var$key) || {};
    timestampMap[issueKey] = new Date().getTime();
    $26c278bb4b945873$var$localStorageProvider.set($26c278bb4b945873$var$key, timestampMap);
};
const $26c278bb4b945873$export$ff25dd7994c58674 = (issueKey)=>{
    const timestampMap = $26c278bb4b945873$var$localStorageProvider.get($26c278bb4b945873$var$key) || {};
    return timestampMap[issueKey] || 0;
};

});


parcelRegister("cj90I", function(module, exports) {

$parcel$export(module.exports, "RedactionOnboardingSpotlight", () => $e3980701f8cd28fb$export$260a30f70633195);

var $eIYf3 = parcelRequire("eIYf3");

var $loFsA = parcelRequire("loFsA");

var $5MnRk = parcelRequire("5MnRk");

var $a8SXq = parcelRequire("a8SXq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1B1XB = parcelRequire("1B1XB");

var $4R6GH = parcelRequire("4R6GH");

var $ehdJY = parcelRequire("ehdJY");

var $koVbs = parcelRequire("koVbs");

var $17Gip = parcelRequire("17Gip");

var $93Yeu = parcelRequire("93Yeu");

var $2gCtH = parcelRequire("2gCtH");

var $koeKL = parcelRequire("koeKL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $7xIlp = parcelRequire("7xIlp");

var $fgsga = parcelRequire("fgsga");
const $e3980701f8cd28fb$export$260a30f70633195 = ({ issue: issue, user: user })=>{
    const data = (0, $8Uumt.useFragment)((0, $a8SXq.default), issue);
    const { showRedactionChangeBoardingOnIssueViewAsViewer: showViewerExp, showRedactionChangeBoardingOnIssueViewAsEditor: showEditorExp } = (0, $8Uumt.useFragment)((0, $5MnRk.default), user);
    const [commitViewerExp] = (0, $8Uumt.useMutation)((0, $loFsA.default));
    const [commitEditorExp] = (0, $8Uumt.useMutation)((0, $eIYf3.default));
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const [permissions] = (0, $17Gip.useProjectPermissions)(projectKey);
    const { isTargetRendered: isTargetRendered } = (0, $1B1XB.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)((0, $fgsga.getInitialSpotlightType)(permissions.canEditIssues, !!showViewerExp, !!showEditorExp));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const redactedFields = (0, $5uXOq.useMemo)(()=>{
        if (data.redactedFields?.edges) return data.redactedFields.edges.map((edge)=>{
            if (edge?.node) {
                const { fieldId: fieldId, typeKey: typeKey } = edge.node;
                return {
                    fieldId: fieldId,
                    typeKey: typeKey
                };
            }
            return null;
        }).filter(Boolean);
        return [];
    }, [
        data?.redactedFields?.edges
    ]);
    const target = (0, $5uXOq.useMemo)(()=>(0, $fgsga.getTargetField)(redactedFields), [
        redactedFields
    ]);
    const onNext = (0, $5uXOq.useCallback)(()=>{
        setActiveSpotlight((0, $3ad1f225ed8090b0$export$4692c1c6d922a293));
    }, [
        setActiveSpotlight
    ]);
    const onReadMore = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.open('https://support.atlassian.com/jira-software-cloud/docs/how-redaction-works/', '_blank');
    }, []);
    const onFinish = (0, $5uXOq.useCallback)(()=>{
        setActiveSpotlight(null);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'redactionChangeBoarding completed');
        if (permissions.canEditIssues) commitEditorExp({
            variables: {
                cloudId: cloudId,
                show: false
            }
        });
        commitViewerExp({
            variables: {
                cloudId: cloudId,
                show: false
            }
        });
    }, [
        cloudId,
        commitEditorExp,
        commitViewerExp,
        createAnalyticsEvent,
        permissions.canEditIssues
    ]);
    const renderSpotlight = (0, $5uXOq.useCallback)(()=>{
        if (activeSpotlight === null || target === null) return null;
        if (activeSpotlight === (0, $3ad1f225ed8090b0$export$aa1a033e13f5d755) && isTargetRendered(`${(0, $3ad1f225ed8090b0$export$aa1a033e13f5d755)}-${target}`) && isTargetRendered((0, $3ad1f225ed8090b0$export$4692c1c6d922a293))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: onNext,
                    text: formatMessage((0, $7xIlp.default).next),
                    autoFocus: true
                },
                {
                    onClick: onFinish,
                    text: formatMessage((0, $7xIlp.default).dismiss)
                }
            ],
            target: `${(0, $3ad1f225ed8090b0$export$aa1a033e13f5d755)}-${target}`,
            actionsBeforeElement: formatMessage((0, $7xIlp.default).onboardingStep1),
            messageType: "transactional",
            messageId: "issue-view-redaction.ui.onboarding.jira-spotlight.spotlight-redaction-message-marker"
        }, formatMessage((0, $7xIlp.default).spotlightRedactionMessage));
        if (activeSpotlight === (0, $3ad1f225ed8090b0$export$33df39b5b5b1ebc2) && isTargetRendered(`${(0, $3ad1f225ed8090b0$export$aa1a033e13f5d755)}-${target}`)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: onFinish,
                    text: formatMessage((0, $7xIlp.default).ok),
                    autoFocus: true
                },
                {
                    onClick: onReadMore,
                    text: formatMessage((0, $7xIlp.default).readMore)
                }
            ],
            target: `${(0, $3ad1f225ed8090b0$export$aa1a033e13f5d755)}-${target}`,
            messageType: "transactional",
            messageId: "issue-view-redaction.ui.onboarding.jira-spotlight.spotlight-redaction-message-marker-viewer"
        }, formatMessage((0, $7xIlp.default).spotlightRedactionMessage));
        if (activeSpotlight === (0, $3ad1f225ed8090b0$export$4692c1c6d922a293) && isTargetRendered((0, $3ad1f225ed8090b0$export$4692c1c6d922a293))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: onFinish,
                    text: formatMessage((0, $7xIlp.default).ok),
                    autoFocus: true
                },
                {
                    onClick: onReadMore,
                    text: formatMessage((0, $7xIlp.default).readMore)
                }
            ],
            target: (0, $3ad1f225ed8090b0$export$4692c1c6d922a293),
            messageType: "transactional",
            messageId: "issue-view-redaction.ui.onboarding.jira-spotlight.spotlight-redaction-message-action-menu",
            actionsBeforeElement: formatMessage((0, $7xIlp.default).onboardingStep2)
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $7xIlp.default).spotlightActionMenuMessageIssueTerminologyRefreshM4 : (0, $7xIlp.default).spotlightActionMenuMessage));
        return null;
    }, [
        activeSpotlight,
        isTargetRendered,
        target,
        onNext,
        formatMessage,
        onReadMore,
        onFinish
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderSpotlight());
};

});
parcelRegister("eIYf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $13087266cce6a52d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f936d5b706683f2e6b6688fc5e492f2>>
 * @relayHash fba7d5d44acaacff5df5be390cf30b1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82cb47c5ffdff692d5f711cc53319e1f8285c458f96c07456619564b649b037d
const $13087266cce6a52d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "show"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "show",
                                    "variableName": "show"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "setShowRedactionChangeBoardingOnIssueViewAsEditor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "82cb47c5ffdff692d5f711cc53319e1f8285c458f96c07456619564b649b037d",
            "metadata": {},
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsEditorMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$13087266cce6a52d$var$node.hash = "20c7889c3fa251dcd753eb816216dbe8";
var $13087266cce6a52d$export$2e2bcd8739ae039 = $13087266cce6a52d$var$node;

});

parcelRegister("loFsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7b05a50fff3c4a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6b043ee851946f7aeaced24ca32ea269>>
 * @relayHash d5c85b9b9fae463c8e45290daac70048
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3178f46ab936b2e7115dee54438829d2af19a1a8f85b028faa20238b6c3a114c
const $b7b05a50fff3c4a9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "show"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "show",
                                    "variableName": "show"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "setShowRedactionChangeBoardingOnIssueViewAsViewer"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3178f46ab936b2e7115dee54438829d2af19a1a8f85b028faa20238b6c3a114c",
            "metadata": {},
            "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b7b05a50fff3c4a9$var$node.hash = "202c2d02b05a4f4679dac304087b8689";
var $b7b05a50fff3c4a9$export$2e2bcd8739ae039 = $b7b05a50fff3c4a9$var$node;

});

parcelRegister("5MnRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $72950a5f51af61e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a4a8d69fd4c9660c19ed4532bd9ba9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72950a5f51af61e8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "showRedactionChangeBoardingOnIssueViewAsViewer"
        },
        {
            "kind": "ScalarField",
            "name": "showRedactionChangeBoardingOnIssueViewAsEditor"
        }
    ],
    "type": "JiraUserPreferences"
};
$72950a5f51af61e8$var$node.hash = "4a6b24a65a54b20cc96b85dbab1d2920";
var $72950a5f51af61e8$export$2e2bcd8739ae039 = $72950a5f51af61e8$var$node;

});

parcelRegister("a8SXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44d05c8ec224c72$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2dda6e3650b409a1a7c69f45de2406d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f44d05c8ec224c72$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue",
    "selections": [
        {
            "concreteType": "JiraFieldConnection",
            "kind": "LinkedField",
            "name": "redactedFields",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$f44d05c8ec224c72$var$node.hash = "3f49fa3ad83dc768dae3ca7ef1527e31";
var $f44d05c8ec224c72$export$2e2bcd8739ae039 = $f44d05c8ec224c72$var$node;

});

parcelRegister("1B1XB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bad88a821808218$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
function $9bad88a821808218$export$2e2bcd8739ae039() {
    const { targets: targets } = (0, $5uXOq.useContext)((0, $imZsD.SpotlightContext));
    const targetRef = (0, $5uXOq.useRef)(targets);
    (0, $5uXOq.useEffect)(()=>{
        targetRef.current = targets;
    }, [
        targets
    ]);
    const isTargetRendered = (0, $5uXOq.useCallback)((target)=>!!targetRef.current[target], []);
    return (0, $5uXOq.useMemo)(()=>({
            isTargetRendered: isTargetRendered
        }), [
        isTargetRendered
    ]);
}

});

const $3ad1f225ed8090b0$export$aa1a033e13f5d755 = 'redaction-marker';
const $3ad1f225ed8090b0$export$33df39b5b5b1ebc2 = 'redaction-marker-viewer';
const $3ad1f225ed8090b0$export$4692c1c6d922a293 = 'issue-action-menu-button';

parcelRegister("7xIlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a59a496299f171a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3a59a496299f171a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightRedactionMessage: {
        "id": "issue.redaction.spotlight-redaction-message",
        "defaultMessage": "The solid bar indicates that your organization detected and deleted sensitive data."
    },
    spotlightActionMenuMessage: {
        "id": "issue.redaction.spotlight-action-menu-message",
        "defaultMessage": "Go to Redactions in this menu to view details about the redactions on this issue."
    },
    next: {
        "id": "issue.redaction.spotlight-next-button",
        "defaultMessage": "Next"
    },
    ok: {
        "id": "issue.redaction.spotlight-ok-button",
        "defaultMessage": "Ok"
    },
    readMore: {
        "id": "issue.redaction.spotlight-read-more-button",
        "defaultMessage": "Read more"
    },
    dismiss: {
        "id": "issue.redaction.spotlight-dismiss-button",
        "defaultMessage": "Dismiss"
    },
    onboardingStep1: {
        "id": "issue-view-redaction.onboarding.onboarding-step-1",
        "defaultMessage": "1/2"
    },
    onboardingStep2: {
        "id": "issue-view-redaction.onboarding.onboarding-step-2",
        "defaultMessage": "2/2"
    },
    spotlightActionMenuMessageIssueTerminologyRefreshM4: {
        "id": "issue.redaction.spotlight-action-menu-message-issue-terminology-refresh-m4",
        "defaultMessage": "Go to Redactions in this menu to view details about the redactions on this work item."
    }
});

});

parcelRegister("fgsga", function(module, exports) {

$parcel$export(module.exports, "getTargetField", () => $d98b322961cbf024$export$8abf31f8698ee47a);
$parcel$export(module.exports, "getInitialSpotlightType", () => $d98b322961cbf024$export$2322157eb6e24c11);

const $d98b322961cbf024$export$8abf31f8698ee47a = (fields)=>{
    const fieldMap = {};
    fields.forEach((field)=>{
        if (field.fieldId) fieldMap[field.fieldId] = field;
    });
    return fieldMap.description?.fieldId || fieldMap.environment?.fieldId || fieldMap.summary?.fieldId || fields.find((field)=>field.typeKey === 'com.atlassian.jira.plugin.system.customfieldtypes:textarea')?.fieldId || fields.find((field)=>field.typeKey === 'com.atlassian.jira.plugin.system.customfieldtypes:textfield')?.fieldId || null;
};
const $d98b322961cbf024$export$2322157eb6e24c11 = (isEditor, showViewerExp, showEditorExp)=>{
    if (isEditor && showEditorExp) return 0, $3ad1f225ed8090b0$export$aa1a033e13f5d755;
    if (showViewerExp) return 0, $3ad1f225ed8090b0$export$33df39b5b5b1ebc2;
    return null;
};

});




//# sourceMappingURL=async-redaction-new-changeboarding-flag.b14be7c5.js.map
